import $ from '../_snowpack/pkg/jquery.js';
import Plyr from '../_snowpack/pkg/plyr.js';

const Video = {
  isVideoPlaying: false,
  plyr: null,
  url: null,
  videoOptions: {
    autoplay: true,
    storage: {
      enabled: false
    },
    fullscreen: {
      enabled: true,
      iosNative: false
    }
  },
  getYouTubeId: function(url) {
    const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
  },
  open: function(url) {
    this.url = url;
    if (!this.isVideoPlaying) $('#video-player').animate({"margin-left": `+=${$('#video-player').outerWidth() + 8 }`});
    $('#player').attr('data-plyr-embed-id', this.getYouTubeId(url));
    this.isVideoPlaying = true;

    if (!this.plyr) {
      this.plyr = new Plyr('#player', this.videoOptions);
      this.plyr.on('ready', this.onReady.bind(this));
    } else {
      this.plyr.source = { sources : [{ provider: 'youtube', src: url }] };
    }
  },
  close: function() {
    this.isVideoPlaying = false;
    this.plyr.stop();
    $('#video-player').animate({"margin-left": `-=${$('#video-player').outerWidth() + 8 }`})
  },
  onReady: function() {
    const params = new URLSearchParams(this.url.split('?')[1]);
    const start = params.get('start');
    if (start) {
      this.plyr.currentTime = +start;
      this.plyr.muted = false;
      this.plyr.play();
    } else {
      this.plyr.play();
    }
  }
}

export default Video;
